<template>
  <div id="app">
    <transition name="loading-fade">
      <div v-if="!siteReady" class="site-loading" role="status" aria-live="polite" aria-label="Loading FGQ website">
        <div class="site-loading__card">
          <img src="@/assets/img/logo3.png" alt="FGQ globe logo">
          <div class="site-loading__line"><span></span></div>
          <p>Loading FGQ</p>
        </div>
      </div>
    </transition>
    <myheader v-if="$store.state.winWidth > 768" v-show="path && path!='feadback' && !path.includes('job')"></myheader>
    <mobheader v-else  v-show="path && !path.includes('job')"></mobheader>
    <main id="main-content">
      <router-view
        :class="{marTop:path=='contactUs' || path== 'news' || path=='afterSale' || path=='guide'}"
        @home-ready="handleHomeReady">
      </router-view>
    </main>
    <myfooter v-if="$store.state.winWidth > 768" v-show="path && path!='feadback' && !path.includes('job')"></myfooter>
    <mobfooter v-else  v-show="path && !path.includes('job')"></mobfooter>
  </div>
</template>

<script>
import myheader from "@/components/Header.vue"
import myfooter from "@/components/Footer.vue"
import mobheader from "@/components/mobHeader.vue"
import mobfooter from "@/components/mobFooter.vue"
import { normalizeEnglishNavigation, normalizeEnglishOptions } from '@/utils/englishContent'
import { trackPageView } from '@/utils/customerTracking'
export default {
  name: 'App',
  components: {
    myheader,
    myfooter,
    mobheader,
    mobfooter
  },
  data() {
    return {
      appReady: false,
      homeReady: false
    }
  },
  computed:{
    path(){
      return this.$route.name
    },
    siteReady() {
      return this.appReady && (this.path !== 'index' || this.homeReady)
    }
  },
  watch: {
    '$route.fullPath': {
      immediate: true,
      handler() {
        this.$nextTick(() => trackPageView(this.$api, 'en'))
      }
    },
    path(nextPath, previousPath) {
      if (nextPath === 'index' && previousPath && previousPath !== 'index') {
        this.homeReady = false
      }
    }
  },
  mounted() {
    Promise.allSettled([this.getNavs(), this.getOption()]).finally(() => {
      this.appReady = true
    })
    this.$store.commit('setWidth', window.innerWidth)
    this.$store.commit('setScroll', window.scrollY)
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('scroll', this.handleScroll)


  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleHomeReady() {
      this.homeReady = true
    },
    handleResize() {
      this.$store.commit('setWidth', window.innerWidth)
      if (window.innerWidth > 768) {
        document.body.style.overflow = ''
      }
    },
    handleScroll() {
      this.$store.commit('setScroll', window.scrollY)
    },
    getNavs() {
      return this.$api.getNavs().then(res => {
        if (res && res.code == 1) {
          const data = normalizeEnglishNavigation(res.data || {})
          this.$store.commit('setMenu', {
            ddsh: data.ddsh || [],
            ddsl: data.ddsl || [],
            fgkj: data.fgkj || [],
            fwzc: data.fwzc || [],
            gywm: data.gywm || [],
            list: data.list || []
          })
        }
      }).catch(() => {})
    },
    getOption() {
      return this.$api.getOption({
        type: "kf_phone,kf_logo,kf_worktime,site_copyright,site_icp,main_logo,second_logo,site_name,site_analytics,zp_logo,zp_company,zp_intro,zp_title,zp_content,site_analytics,city"
      }).then(res => {
        if (res && res.code == 1) {
          this.$store.commit('setdataInfo', normalizeEnglishOptions(res.data || {}))
        }
      }).catch(() => {})
    },
  },
}
</script>

<style scoped>
.site-loading {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: grid;
  place-items: center;
  background:
    radial-gradient(circle at 50% 38%, rgba(176, 13, 22, 0.08), transparent 32%),
    #f7f7f5;
}

.site-loading__card {
  width: min(360px, 72vw);
  text-align: center;
}

.site-loading__card img {
  width: min(96px, 24vw);
  height: auto;
  object-fit: contain;
}

.site-loading__card p {
  margin: 20px 0 0;
  color: #5c5c5c;
  font-size: 14px;
  letter-spacing: 0.06em;
}

.site-loading__line {
  width: 100%;
  height: 3px;
  margin-top: 30px;
  overflow: hidden;
  border-radius: 999px;
  background: #e4e4e1;
}

.site-loading__line span {
  display: block;
  width: 42%;
  height: 100%;
  border-radius: inherit;
  background: #b00d16;
  animation: site-loading 1.15s ease-in-out infinite;
}

.loading-fade-leave-active {
  transition: opacity 0.3s ease;
}

.loading-fade-leave-to {
  opacity: 0;
}

@keyframes site-loading {
  from { transform: translateX(-110%); }
  to { transform: translateX(250%); }
}

@media (prefers-reduced-motion: reduce) {
  .site-loading__line span { animation-duration: 2.4s; }
}
</style>
